// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"3d1e64e4d5dc30322a7f","303":"c1d354cfdc671db0e827","495":"0cb7557d23660dd3f9c8"}[chunkId] + ".js";
};